import { v4 as uuidv4 } from 'uuid';
import { Status, SurveyResponse } from 'types/surveyResponse';
import { VisitCustomer, Visit } from 'types/customer';
import { useAuthentication } from 'hooks/useAuthentication';
import { useCreateSurveyResponse } from './mutations';

export const useStartSurvey = () => {
  const createSurveyMutation = useCreateSurveyResponse();
  const { user } = useAuthentication();

  return async (
    surveyDefinitionId: string,
    surveyVersion: string,
    customerId: string | undefined,
    customerName: string | undefined,
    customer: VisitCustomer | undefined,
    visit: Visit | undefined
  ) => {
    const id = uuidv4();
    const surveyResponse: SurveyResponse = {
      id,
      responseId: id,
      surveyDefinitionId,
      surveyVersion,
      status: Status.NotStarted,
      statusHistory: [{ status: Status.NotStarted, changedAt: new Date().toISOString() }],
      customerId,
      customerName,
      customer,
      visit,
      representativeId: user?.userId || '',
      createdAt: new Date().toISOString(),
      sections: [],
      _deleted: false
    };

    return await createSurveyMutation.mutateAsync(surveyResponse);
  };
};
